import CashReceiptsCreate from "./CashReceiptsCreate";

export default {
  name: "cashReceipts",
  create: CashReceiptsCreate,
};